export default {
  allChatData: {}, // 所有聊天记录
  chatMsgList: [], // 与指定用户的聊天记录
  needScrollToBottom: true,
  canLoadMore: {}, // 当前会话是否能加载更多
  userList: [], // 与当前账号的历史聊天用户
  conversationList: [], // 暂缓区，用于获取聊天记录后更新聊天用户列表
  sendingUser: '', // 存在当前IM账号
  imRole: '',
  receivingUser: '',
  receiver: {},
  chatDialogVisible: false,
  exhibitorDialogVisible: false,
  chatEmployeeList: [],
  emediaChatVisible: false,
  isChatConnecting: '', // waiting 等待连接中 closed 关闭链接 linked 已连接
  newMessageComing: false,
  newMailComing: false,
  onlineServices: [], // 在线客服数组
  touristService: null, // 游客在线客服（只有一个）
  onlineServiceTel: '',
  streamType:'',
  onRinging: false,
  contact: '',
  isCallerWaiting: false,
  fetchImMsgStatus: false, //环信消息拉取是否完成
  onLine: false, //环信本机网络状态

  // 员工管理
  employeeDetail: {},
}
